import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isEmpty from "lodash/isEmpty";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.define-property.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import moment from 'moment';
import { dateFormat, CREDITS_SEARCH_TYPE } from 'enums';
var number = CREDITS_SEARCH_TYPE.number,
    borrower_name = CREDITS_SEARCH_TYPE.borrower_name,
    borrower_id_number = CREDITS_SEARCH_TYPE.borrower_id_number,
    borrower_phone = CREDITS_SEARCH_TYPE.borrower_phone,
    area = CREDITS_SEARCH_TYPE.area,
    city = CREDITS_SEARCH_TYPE.city,
    address = CREDITS_SEARCH_TYPE.address;
export var creditBody = function creditBody(data) {
  return _objectSpread(_objectSpread({}, data), {}, {
    date: moment.isMoment(data === null || data === void 0 ? void 0 : data.date) ? data === null || data === void 0 ? void 0 : data.date.format('YYYY-MM-DD') : moment(data === null || data === void 0 ? void 0 : data.date, dateFormat).format('YYYY-MM-DD')
  });
};

var getDocumentImagesModel = function getDocumentImagesModel(response) {
  if (_isEmpty(response)) return null;
  var obj = {};
  response === null || response === void 0 ? void 0 : response.forEach(function (el) {
    obj[el === null || el === void 0 ? void 0 : el.type] = _objectSpread(_objectSpread({}, el), {}, {
      data: el === null || el === void 0 ? void 0 : el.image,
      name: el === null || el === void 0 ? void 0 : el.type
    });
  });
  return obj;
};

export var getCreditModel = function getCreditModel(data) {
  var _data$borrower, _data$borrower$phones, _data$borrower2;

  return _objectSpread(_objectSpread({}, data), {}, {
    borrower: _objectSpread(_objectSpread({}, data === null || data === void 0 ? void 0 : data.borrower), {}, {
      phones: data === null || data === void 0 ? void 0 : (_data$borrower = data.borrower) === null || _data$borrower === void 0 ? void 0 : (_data$borrower$phones = _data$borrower.phones) === null || _data$borrower$phones === void 0 ? void 0 : _data$borrower$phones.map(function (el) {
        return el === null || el === void 0 ? void 0 : el.phone;
      }),
      id_card_images: getDocumentImagesModel(data === null || data === void 0 ? void 0 : (_data$borrower2 = data.borrower) === null || _data$borrower2 === void 0 ? void 0 : _data$borrower2.id_card_images)
    })
  });
};
export var creditModel = function creditModel(data) {
  return _objectSpread(_objectSpread({}, data === null || data === void 0 ? void 0 : data.credit), {}, {
    payment_plan: data === null || data === void 0 ? void 0 : data.payment_plan,
    home_visit_fee_payment_plan: data === null || data === void 0 ? void 0 : data.home_visit_fee_payment_plan,
    combined_payment_plan: data === null || data === void 0 ? void 0 : data.combined_payment_plan,
    total_home_visit_fee: data === null || data === void 0 ? void 0 : data.total_home_visit_fee
  });
};
export var allCreditsParams = function allCreditsParams(data) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (data === null || data === void 0 ? void 0 : data.pageSize) && {
    per_page: data === null || data === void 0 ? void 0 : data.pageSize
  }), (data === null || data === void 0 ? void 0 : data.pageIndex) && {
    page: (data === null || data === void 0 ? void 0 : data.pageIndex) + 1
  }), (data === null || data === void 0 ? void 0 : data.search) && (data === null || data === void 0 ? void 0 : data.searchBy) === number && {
    number: data === null || data === void 0 ? void 0 : data.search
  }), (data === null || data === void 0 ? void 0 : data.search) && (data === null || data === void 0 ? void 0 : data.searchBy) === borrower_name && {
    borrower_name: data === null || data === void 0 ? void 0 : data.search
  }), (data === null || data === void 0 ? void 0 : data.search) && (data === null || data === void 0 ? void 0 : data.searchBy) === borrower_id_number && {
    borrower_id_number: data === null || data === void 0 ? void 0 : data.search
  }), (data === null || data === void 0 ? void 0 : data.search) && (data === null || data === void 0 ? void 0 : data.searchBy) === borrower_phone && {
    borrower_phone: data === null || data === void 0 ? void 0 : data.search
  }), (data === null || data === void 0 ? void 0 : data.search) && (data === null || data === void 0 ? void 0 : data.searchBy) === area && {
    area: data === null || data === void 0 ? void 0 : data.search
  }), (data === null || data === void 0 ? void 0 : data.search) && (data === null || data === void 0 ? void 0 : data.searchBy) === city && {
    city: data === null || data === void 0 ? void 0 : data.search
  }), (data === null || data === void 0 ? void 0 : data.search) && (data === null || data === void 0 ? void 0 : data.searchBy) === address && {
    address: data === null || data === void 0 ? void 0 : data.search
  }), (data === null || data === void 0 ? void 0 : data.status) && {
    status: data === null || data === void 0 ? void 0 : data.status
  }), (data === null || data === void 0 ? void 0 : data.loanDuration) && {
    period_months: data === null || data === void 0 ? void 0 : data.loanDuration
  }), (data === null || data === void 0 ? void 0 : data.countUnpaidPayments) && {
    count_unpaid_payments: data === null || data === void 0 ? void 0 : data.countUnpaidPayments
  }), (data === null || data === void 0 ? void 0 : data.daysExpired) && {
    days_late: data === null || data === void 0 ? void 0 : data.daysExpired
  }), {}, {
    amount_operation_more_or_equal: data === null || data === void 0 ? void 0 : data.overUnder
  }, (data === null || data === void 0 ? void 0 : data.priceTag) && {
    credit_amount: data === null || data === void 0 ? void 0 : data.priceTag
  }), (data === null || data === void 0 ? void 0 : data.employee) && {
    employee_id: data === null || data === void 0 ? void 0 : data.employee
  }), (data === null || data === void 0 ? void 0 : data.approvedBy) && {
    approved_by: data === null || data === void 0 ? void 0 : data.approvedBy
  }), (data === null || data === void 0 ? void 0 : data.office) && {
    office_id: data === null || data === void 0 ? void 0 : data.office
  }), (data === null || data === void 0 ? void 0 : data.startDate) && {
    date_from: data === null || data === void 0 ? void 0 : data.startDate
  }), (data === null || data === void 0 ? void 0 : data.endDate) && {
    date_to: data === null || data === void 0 ? void 0 : data.endDate
  }), (data === null || data === void 0 ? void 0 : data.maturityStartDate) && {
    next_payment_date_from: data === null || data === void 0 ? void 0 : data.maturityStartDate
  }), (data === null || data === void 0 ? void 0 : data.maturityEndDate) && {
    next_payment_date_to: data === null || data === void 0 ? void 0 : data.maturityEndDate
  }), (data === null || data === void 0 ? void 0 : data.sortBy) && {
    sort_by: data === null || data === void 0 ? void 0 : data.sortBy
  }), (data === null || data === void 0 ? void 0 : data.direction) && {
    direction: data === null || data === void 0 ? void 0 : data.direction
  });
};
export var documentParams = function documentParams(data) {
  return _objectSpread(_objectSpread({}, (data === null || data === void 0 ? void 0 : data.type) && {
    type: data === null || data === void 0 ? void 0 : data.type
  }), (data === null || data === void 0 ? void 0 : data.document_id) && {
    document_id: data === null || data === void 0 ? void 0 : data.document_id
  });
};
export var creditPaymentModel = function creditPaymentModel(data) {
  return _objectSpread(_objectSpread({}, data), {}, {
    early_payment: data !== null && data !== void 0 && data.early_payment ? 1 : 0
  });
};